import React from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import '../App.css';
import { PersonalGraph } from './PersonalGraph';
import PersonalTable from './PersonalTable';

type GraphStatus = {
  assignee_user: string;
  target_sales: number;
  actual_sales: number;
  target_gross_profit: number;
  actual_gross_profit: number;
  goal_achievement_rate: number;
  assignee_user_id: any;
  in_progress_target: number;
  in_progress_performance: number;
  in_progress_achievement_rate: number;
  construction_target: number;
  construction_performance: number;
  construction_achievement_rate: number;
  completion_target: number;
  completion_performance: number;
  completion_achievement_rate: number;

  // res["in_progress_achievement_rate"] = 0
  // res["construction_target"] = 0
  // res["construction_performance"] = 0
  // res["construction_achievement_rate"] = 0
  // res["completion_target"] = 0
  // res["completion_performance"] = 0
  // res["completion_achievement_rate"] = 0
};

type GraphStatuses = {
  currency: number;
  graphStatus: GraphStatus[];
};

function createTableData(
  assignee_user: string,
  target_sales: number,
  actual_sales: number,
  target_gross_profit: number,
  actual_gross_profit: number,
  goal_achievement_rate: number,
  assignee_user_id: any,
  in_progress_target: number,
  in_progress_performance: number,
  in_progress_achievement_rate: number,
  construction_target: number,
  construction_performance: number,
  construction_achievement_rate: number,
  completion_target: number,
  completion_performance: number,
  completion_achievement_rate: number
) {
  return {
    assignee_user,
    target_sales,
    actual_sales,
    target_gross_profit,
    actual_gross_profit,
    goal_achievement_rate,
    assignee_user_id,
    in_progress_target,
    in_progress_performance,
    in_progress_achievement_rate,
    construction_target,
    construction_performance,
    construction_achievement_rate,
    completion_target,
    completion_performance,
    completion_achievement_rate
  };
}

function createGraphData(
  assignee_user: string,
  target_sales: number,
  actual_sales: number,
  target_gross_profit: number,
  actual_gross_profit: number,
  goal_achievement_rate: number,
  in_progress_target: number,
  in_progress_performance: number,
  in_progress_achievement_rate: number,
  construction_target: number,
  construction_performance: number,
  construction_achievement_rate: number,
  completion_target: number,
  completion_performance: number,
  completion_achievement_rate: number
) {
  return {
    assignee_user,
    target_sales,
    actual_sales,
    target_gross_profit,
    actual_gross_profit,
    goal_achievement_rate,
    in_progress_target,
    in_progress_performance,
    in_progress_achievement_rate,
    construction_target,
    construction_performance,
    construction_achievement_rate,
    completion_target,
    completion_performance,
    completion_achievement_rate
  };
}

const PersonalContainer: React.FC<GraphStatuses> = graphStatuses => {
  const matches = useMediaQuery('(min-width:600px)');
  const matches2 = useMediaQuery('(min-width:900px)');
  //const [sortValue, setSortValue] = useRecoilState(isSortValue);

  const personalTableData = graphStatuses.graphStatus.map((output, index) => {
    return createTableData(
      output.assignee_user,
      output.target_sales,
      output.actual_sales,
      output.target_gross_profit,
      output.actual_gross_profit,
      output.goal_achievement_rate,
      output.assignee_user_id,
      output.in_progress_target,
      output.in_progress_performance,
      output.in_progress_achievement_rate,
      output.construction_target,
      output.construction_performance,
      output.construction_achievement_rate,
      output.completion_target,
      output.completion_performance,
      output.completion_achievement_rate
    );
  });

  const personalGraphData = graphStatuses.graphStatus.map((output, index) => {
    return createGraphData(
      output.assignee_user,
      output.target_sales,
      output.actual_sales,
      output.target_gross_profit,
      output.actual_gross_profit,
      output.goal_achievement_rate,
      output.in_progress_target,
      output.in_progress_performance,
      output.in_progress_achievement_rate,
      output.construction_target,
      output.construction_performance,
      output.construction_achievement_rate,
      output.completion_target,
      output.completion_performance,
      output.completion_achievement_rate
    );
  });

  return (
    <div>
      <div
        style={{
          marginBottom: !matches2 ? 10 : 0,
          fontSize: !matches ? 20 : 24,
          fontWeight: 'bold',
          padding: !matches ? 15 : 20,
          display: 'flex'
        }}
      >
        目標と実績（個人）
        {/* <div
          className="select-div"
          style={{ marginBottom: 30 }}
        >
          <div style={{ paddingLeft: 5 }}>
            <FormControl className={classes.formControl1}>
              <NativeSelect
                value={sortValue}
                onChange={(e) => {
                  setSortValue(e.target.value);
                }}
                inputProps={{ "aria-label": "age" }}
                disableUnderline
              >
                {dropDownValues.map((item: any, index: any) => (
                  <option value={Object.keys(item)}>{Object.values(item)}</option>
                ))}
              </NativeSelect>
            </FormControl>
          </div>
        </div> */}
      </div>
      <Grid className={'grid-bottom-container-bg'} container>
        <Grid item xs={!matches2 ? 12 : 6}>
          <PersonalTable
            currency={graphStatuses.currency}
            graphStatus={personalTableData}
          />
        </Grid>
        <Grid style={{ overflow: 'scroll' }} item xs={!matches2 ? 12 : 6}>
          <PersonalGraph graphStatus={personalGraphData} />
        </Grid>
      </Grid>
      <div style={{ height: 15, backgroundColor: '#F5F5F5' }} />
      <div
        style={{
          marginBottom: !matches2 ? 10 : 0,
          fontSize: !matches ? 20 : 24,
          fontWeight: 'bold',
          padding: !matches ? 15 : 20
        }}
      >
        個人工事実績一覧
      </div>
      {/* <div style={{ height: 15, backgroundColor: "#F5F5F5" }} />
      <div
        style={{
          marginBottom: !matches2 ? 10 : 0,
          fontSize: !matches ? 20 : 24,
          fontWeight: "bold",
          padding: !matches ? 15 : 20,
        }}
      >
        工事別実績
      </div> */}
    </div>
  );
};
export default PersonalContainer;
